import ListView from "../framework/ListView.js";
import BaseView from "./BaseView.js";
var Backbone_ListView = BaseView.decorate(ListView);
export { Backbone_ListView as default };
